const SelectParameter = ({ Parameters, selectedParameter, setSelectedParameter, disabled }) => {
    return (
        <select
        id='choice-select'
        className='choice-select'
        value={selectedParameter}
        onChange={(e) => setSelectedParameter(e.target.value)}
        disabled={disabled}
        >
            {Parameters.map((parameter) => (
                <option
                    key={parameter}
                    value={parameter}
                >
                    {parameter}
                </option>
            ))}
        </select>
    );
};

export default SelectParameter;